/**
 * @generated SignedSource<<bbae9ede3071f46c2fa22038ac285fe6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateAndroidPushNotificationCredentialsInput = {
  brandId: string;
  clientEmail: string;
  privateKey: string;
  projectId: string;
};
export type InternNotificationsCardUpdateAndroidMutation$variables = {
  input: UpdateAndroidPushNotificationCredentialsInput;
};
export type InternNotificationsCardUpdateAndroidMutation$data = {
  readonly updateAndroidPushNotificationCredentials: {
    readonly " $fragmentSpreads": FragmentRefs<"InternNotificationsCard_brand">;
  };
};
export type InternNotificationsCardUpdateAndroidMutation = {
  response: InternNotificationsCardUpdateAndroidMutation$data;
  variables: InternNotificationsCardUpdateAndroidMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternNotificationsCardUpdateAndroidMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateAndroidPushNotificationCredentials",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternNotificationsCard_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternNotificationsCardUpdateAndroidMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateAndroidPushNotificationCredentials",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iosPushNotificationCredentialsSetInAzure",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iosPushNotificationCredentialsRequireServiceKeyMigration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iosPushNotificationCertExpirationDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "androidPushNotificationCredentialsSetInAzure",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "androidPushNotificationRequiresFcmv1Migration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandPushNotificationStats",
            "kind": "LinkedField",
            "name": "pushNotificationStats",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notificationsSent30d",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pushDeliveries30d",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pushTaps30d",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tapRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalRegisteredDevices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosDevices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidDevices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PushNotificationDailyMetric",
                "kind": "LinkedField",
                "name": "dailyMetrics",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveries",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "taps",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "azureNotificationsHubName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosAscTeamId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosAppIdentifier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosPushNotificationServiceKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosPushNotificationServiceKeyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidPushNotificationFcmv1PrivateKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidPushNotificationFcmv1ProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidPushNotificationFcmv1ClientEmail",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "153abe801da293642aff3b6d1e45d6d4",
    "id": null,
    "metadata": {},
    "name": "InternNotificationsCardUpdateAndroidMutation",
    "operationKind": "mutation",
    "text": "mutation InternNotificationsCardUpdateAndroidMutation(\n  $input: UpdateAndroidPushNotificationCredentialsInput!\n) {\n  updateAndroidPushNotificationCredentials(input: $input) {\n    ...InternNotificationsCard_brand\n    id\n  }\n}\n\nfragment InternNotificationsCard_brand on BrandType {\n  id\n  displayName\n  iosPushNotificationCredentialsSetInAzure\n  iosPushNotificationCredentialsRequireServiceKeyMigration\n  iosPushNotificationCertExpirationDate\n  androidPushNotificationCredentialsSetInAzure\n  androidPushNotificationRequiresFcmv1Migration\n  pushNotificationStats {\n    notificationsSent30d\n    pushDeliveries30d\n    pushTaps30d\n    tapRate\n    totalRegisteredDevices\n    iosDevices\n    androidDevices\n    dailyMetrics {\n      date\n      deliveries\n      taps\n    }\n  }\n  appConfig {\n    id\n    azureNotificationsHubName\n    iosAscTeamId\n    iosAppIdentifier\n    iosPushNotificationServiceKey\n    iosPushNotificationServiceKeyId\n    androidPushNotificationFcmv1PrivateKey\n    androidPushNotificationFcmv1ProjectId\n    androidPushNotificationFcmv1ClientEmail\n  }\n}\n"
  }
};
})();

(node as any).hash = "d83266ea5a2b36f1aba25750d07faaea";

export default node;
